import {Chip, Stack} from "@mui/material";
import {CAMPAIGN_STATUSES, statusColors, statusLabels} from "../constants";

// Status counts; pass `onSelect` to use the chips as a status filter
export const CampaignStatusChips = ({statusCounts, selected, onSelect}) => {
  return (
    <Stack direction="row" gap={0.5} flexWrap="wrap">
      {CAMPAIGN_STATUSES.map(status => (
        <Chip
          key={status} size="small"
          variant={selected === status ? "filled" : "outlined"}
          color={statusColors[status]}
          label={`${statusLabels[status]}: ${statusCounts?.[status] ?? 0}`}
          onClick={onSelect ? () => onSelect(selected === status ? null : status) : undefined}
        />
      ))}
    </Stack>
  )
}
